import React from 'react';
import "../style/readMoreStyle.scss"
import {Link} from "react-router-dom";
import { withTranslation } from 'react-i18next';

const ReadMoreComponent = (props) => {

    const { tags, t } = props;

    return (
        <div id="contentReadMore">
            <p>{t('Tags', 'Tags')}: </p>

            <ul>
                {tags.map( (tags, index) => {
                    return (
                        <li key={index}>
                            <Link to={`/products/?tags=${tags.name}`}>
                                #{tags.name}
                            </Link>
                        </li>
                    )
                })}
            </ul>
        </div>
    );
};

export default withTranslation()(ReadMoreComponent);